import React from 'react';
import {useDropzone} from 'react-dropzone';
import {useTranslation} from 'react-i18next';
import {ReactComponent as ImageIcon} from '../../assets/icons/image-icon.svg';
import './styles.scss';

type IProps = {
  onDrop: any;
};

const Dropzone: React.FC<IProps> = ({onDrop}) => {
  // Hooks
  const {getRootProps, getInputProps, isDragActive} = useDropzone({
    onDrop,
    accept: {
      'image/png': ['.png'],
      'image/jpeg': ['.jpeg'],
      'image/jpg': ['.jpg'],
      'video/*': ['.mp4'],
    },
    maxFiles: 1,
    multiple: false,
  });
  const {t} = useTranslation();

  return (
    <div className="dropzone-div" {...getRootProps()}>
      <input className="dropzone-input" {...getInputProps()} />
      {isDragActive ? (
        <p className="dropzone-content">{t('global:dropFileRelease')}</p>
      ) : (
        <div className="dropzone-content">
          <div className="image-icon">
            <ImageIcon />
          </div>
          <div className="text-description">
            <span className="select-word">{t('global:select')}</span>
            &nbsp;
            {t('global:dropFileSelect')}
          </div>
        </div>
      )}
    </div>
  );
};

export default Dropzone;
